import {
  Component, EventEmitter, Input, OnInit, Output  
} from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Post, PostReaction } from "../../../app/app.interfaces";
import { ApiService } from "../../../services/api.service";
import { IonicHelper } from "../../../helpers/ionic.helper";
import { FormHelper } from "../../../helpers/form.helper";
import { ButtonStyle } from '../../upload/file-upload';

@Component({
  selector: 'reaction-edit',
  templateUrl: 'reaction-edit.html'
})

export class ReactionEdit implements OnInit {

  form: FormGroup;
  buttonStyleButton = ButtonStyle.Button;

  @Input() reaction: PostReaction;
  @Output() reactionChange: EventEmitter<PostReaction|void> = new EventEmitter<PostReaction|void>();

  constructor(private formBuilder: FormBuilder,
              private apiService: ApiService,
              private ionic: IonicHelper,
              private formHelper: FormHelper
              ) {

  }
  

  ngOnInit(): void {
    
    if (this.reaction) {
			if (!this.reaction.userHasModeratingAccess) {
				throw new Error('User does not have moderating access to reaction ' + this.reaction.id);
			}
			
			
      this.formHelper.buildPostReactionForm(this.reaction).then((form) => {
        this.form = form;
      });


    }
  }

  submitForm(): void {

    this.ionic.toggleLoader(true);
    
    if(this.form.valid) {
      
      //new way:
      let changedReaction = FormHelper.updateObjectWithFormValues(this.reaction, this.form);
      

      this.apiService.updateResource( changedReaction ).then((updatedReaction: PostReaction) => {
        this.ionic.toggleLoader(false);
        this.ionic.toast('REACTION.UPDATED');
        this.reaction = updatedReaction;
        this.reactionChange.emit(this.reaction);
      }).catch((err)=>{
        console.error(err);
        this.ionic.toggleLoader(false);
        this.ionic.alert('GLOBAL.GENERAL_ERROR');
      });
    }
    else {
      this.ionic.toggleLoader(false);
      this.ionic.invalidFieldsAlert(
				'REACTION.ERROR',
				null,
				'REACTION.ERRORS',
				FormHelper.getInvalidFormControls(this.form.controls)
    	);
    }

  }
  

	addAttachmentField(): void {    
    let newFormControl = new FormControl(null);
    let attachmentControls = this.form.get('attachments') as FormArray;
    attachmentControls.push(newFormControl);
  }
	
  attachmentUploadError(ev){
    this.ionic.alert('POST_CREATE.ADD_ATTACHMENT_ERROR');
  }
  
	removeAttachmentField(i): void {
    (this.form.get('attachments') as any).removeAt(i);
  }
  

}




// WEBPACK FOOTER //
// ./src/partials/reaction/reaction-edit/reaction-edit.ts